<script setup lang="ts">
import { computed } from 'vue';
import type { Component } from 'vue';
import CellName from './cells/CellName.vue';
import CellDate from './cells/CellDate.vue';
import CellIban from './cells/CellIban.vue';
import CellRawIban from './cells/CellRawIban.vue';
import CellReference from './cells/CellReference.vue';
import CellUser from './cells/CellUser.vue';
import CellStatus from './cells/CellStatus.vue';
import CellAmount from './cells/CellAmount.vue';
import CellCurrency from './cells/CellCurrency.vue';
import CellLastActivity from './cells/CellLastActivity.vue';
import CellBalance from './cells/CellBalance.vue';
import CellAction from './cells/CellAction.vue';

export type UiCellType =
  | 'name'
  | 'date'
  | 'iban'
  | 'rawIban'
  | 'reference'
  | 'user'
  | 'status'
  | 'amount'
  | 'currency'
  | 'lastActivity'
  | 'balance'
  | 'action';

const CELL_MAP: Record<UiCellType, Component> = {
  name: CellName,
  date: CellDate,
  iban: CellIban,
  rawIban: CellRawIban,
  reference: CellReference,
  user: CellUser,
  status: CellStatus,
  amount: CellAmount,
  currency: CellCurrency,
  lastActivity: CellLastActivity,
  balance: CellBalance,
  action: CellAction,
};

export interface TableColumnConfig {
  key: string;
  field?: string;
  header: string;
  sortable?: boolean;
  style?: string;
  headerStyle?: string;
  headerClass?: string;
  exportable?: boolean;
  class?: string;
  bodySlot?: UiCellType;
  cellProps?: Record<string, unknown>;
}

defineOptions({ inheritAttrs: false });

const { name, row } = defineProps<{
  name: UiCellType;
  row: Record<string, unknown>;
}>();

const resolvedCell = computed(() => CELL_MAP[name]);
</script>

<template>
  <component :is="resolvedCell" :row="row" v-bind="$attrs">
    <template v-if="$slots.action" #action="slotProps">
      <slot name="action" v-bind="slotProps" />
    </template>
  </component>
</template>
